export function mensagemDeErro(erro: any, padrao: string): string {
  const mensagem = erro?.response?.data?.message;

  if (Array.isArray(mensagem)) {
    return mensagem.join(", ") || padrao;
  }

  return typeof mensagem === "string" && mensagem ? mensagem : padrao;
}
